<template>
  <label class="switch-toggle" :class="{ disabled: disabled }">
    <input 
      type="checkbox" 
      :checked="value" 
      :disabled="disabled"
      @click.prevent="$emit('input', !value)"
    >
    <span class="slider"></span>
  </label>
</template>

<script>
export default {
  name: 'SwitchToggle',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.switch-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin-bottom: 0;

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    .slider {
      cursor: not-allowed;
    }
  }

  input { 
    opacity: 0;
    width: 0;
    height: 0;
    
    &:checked + .slider {
      background-color: $color-aqua-green;
      border-color: $color-aqua-green;
    }

    &:focus + .slider {
      box-shadow: 0 0 0 0.25rem rgba(45, 172, 145, 0.25);
    }

    &:checked + .slider:before {
      transform: translateX(20px);
    }
    
    &:disabled + .slider {
      background-color: #e9ecef;
      border-color: #dee2e6;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e9ecef;
    border: 1px solid #dee2e6;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    border-radius: 24px;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: transform .15s ease-in-out;
      border-radius: 50%;
      box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    }
  }
}
</style>
